<template>
	<div class="contents">
		<h3 class="mark">
			<div class="type">
				<span>
					<img src="../assets/result-detail-invest-icon01.svg" alt="*" />あなたの自己投資マインド
				</span>
			</div><!-- end .type -->
			<div class="cover">
				変革型{{investMindResult.percentageLeft}}%、保守型{{investMindResult.percentageRight}}%
			</div><!-- end .cover -->
		</h3><!-- end .mark -->
		<div class="sentence">
			<div class="catch">
				<span class="left">
					Detailed
				</span>
				<span class="right">
					explanation
				</span>
			</div><!-- end .catch -->
			<!-- ////////////////////////////////////////////////////////////////////////// -->
			<!-- ++++++++++++++++++++++++++++++ Paragraphr01 ++++++++++++++++++++++++++++++ -->
			<!-- ////////////////////////////////////////////////////////////////////////// -->	
			<h2>自己成長や自己研鑽のための投資を行うマインドを備え持つ</h2>
			<img src="../assets/result-detail-invest-inleft01.svg" alt="*" class="visual" />
			<div class="caption">
				自己投資は、内向的時間の質を豊かにし、いち早く成長し、大きく羽ばたくきっかけとなる
			</div><!-- end .caption -->
			<p>2番目は自己投資の特性を診断しました。なぜなら、内向性の高い人ほど、自己投資で受けられるリターンが非常に大きくなる可能性を秘めているからです。</p>
			<p>内向的な人は外向的な人よりも、専門的に深く掘り下げることに適しています。また、自分を俯瞰して捉え、戦略を打つのも上手ですから、自己投資でより確実に成果を得る資質も備えています。</p>
			<p>あなたの自己投資は変革型{{investMindResult.percentageLeft}}%という結果は、あなたの内向度{{levelResult.percentage}}%と非常に相性が良いです。このままのスタイルを続けていけば、自身をより豊かな方向性へ導くことができるでしょう。</p>
			<!-- ////////////////////////////////////////////////////////////////////////// -->
			<!-- ++++++++++++++++++++++++++++++ Paragraphr02 ++++++++++++++++++++++++++++++ -->
			<!-- ////////////////////////////////////////////////////////////////////////// -->			
			<h2>あなたは常に、センスのない器用貧乏なるか、大きく稼ぐゼネラリストになるのかの瀬戸際にいる</h2>
			<img src="../assets/result-detail-invest-inleft02.svg" alt="*" class="visual" />
			<div class="caption">
				程よく乱雑に、程よく丁寧に目の前のことに徹することで、多様な投資のリターンをきんと得られるようになる
			</div><!-- end .caption -->
			<p>先程までは褒めちぎりましたが、あなたには危うい点があります。それは、あなたが何かの1つのキャリアを確立する前に、手広く自己投資を行ってしまっていると、どれも中途半端になりかねないということです。何か1つのジャンルでプロフェッショナルなレベルを保ちながら、その知見を他のジャンルで生かし、自己投資するほうが、あなたらしい成功を得続けることに繋がるでしょう。</p>
			<p>内向的で自己投資が変革的なあなたは、自分が何かをインストールすることに大きな興味を持ちがちです。そこで生じがちな問題として、「器用貧乏」になってしまうというものがあります。</p>
			<p>もしも、あなたが「力はあるのに稼げない」、「力はあるのに上手く生かしきれない」と感じているのであれば、自分の力を外部や公開する機会を増やしたり、自分の本質をうまく伝える力を磨くと良いでしょう。</p>

			<div v-if="sacrificeMindResult.percentageLeft >= 50">
				<p>また、先ほどの結果から、あなたは他人本位の度合いが非常に高いことが分かっています。あなたは、自分が身に付けた知識やスキルが相手にどのような影響を与えるのかを上手に把握することができます。</p>
				<p>そのため、自分の持っている知識やスキルで相手を幸せにする「ギブ」の機会が増えれば、あなたの人生が大きく変わる「テイク」がやってくるでしょう。</p>
			</div>

			<!-- ////////////////////////////////////////////////////////////////////////// -->
			<!-- ++++++++++++++++++++++++++++++ Paragraphr03 ++++++++++++++++++++++++++++++ -->
			<!-- ////////////////////////////////////////////////////////////////////////// -->	
			<h2>自己完結の習慣を磨いて、自身の内向性に合った自己投資を選択できるようになろう</h2>
			<img src="../assets/result-detail-invest-inleft03.svg" alt="*" class="visual" />
			<div class="caption">
				自己解決や自分のチャレンジに投資して、自分のことである程度忙しくなってしまえばいい
			</div><!-- end .caption -->

			<p>あなたの内向性と投資の特徴をいかんなく生かすため取り組んでほしいことは、本当に好きなことを見つけ、没頭し、自分の軸を作るということ。あなたは好きなことに関しては、高い内向性で主体的かつ哲学的に行動を取ることができます。</p>
			<p>自分の好きな自分事で忙しくなってしまえば、投資も自分を成長させるものを選ぶはずです。内向性が高い人ほど、「お金でお金を増やす」「単に稼ぐ」といった投資を嫌う傾向にあります。遠回りに見える投資であっても、自己成長や自己解決を中心に投資を試みて下さい。</p>
			<p>
				難点を上げるとすれば、投資が変革型かつ内向性が高いあなたは、「投資が自己流になりがち」です。ですから、他人からのアドバイスや他人の手法をそのまま真似てみるような機会を増やし、投資が独りよがりにならないように注意しましょう。
			</p>
			<p>
				適切なアドバイスやバックアップをくれるキーパーソンに出会えると、あなたの投資のフィードバックは非常に大きくなります。内向型のあなたは、ある程度の知識やリテラシーを磨けば、人を思慮深く判断することもできます。自分の思考や感覚のパターンとはまったく異なる専門家や成功者との出会いに定期的にお金を払ってみるのもとても良いです。</p>
			<p>このように、あなたの内向性は、自身の潜在意識の癖を上手に利用するだけで、人生を大きく上昇させることができるのです。</p>
		</div><!-- end .sentence -->
</div><!-- end .contents -->				
</template>

<script>


export default {
	name: 'ResultDetailInvestInLeft',
	components: {

	},
	
	data: function () {
		return {

		}
	},
	props:[
	],
	computed: {
		//level
		levelResult:function(){
			return this.$store.getters.levelResult
		},
		//sacrificeMind
		sacrificeMindResult:function(){
			return this.$store.getters.sacrificeMindResult
		},	
		//investMind
		investMindResult:function(){
			return this.$store.getters.investMindResult
		},		
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">



</style>
